import React from "react";
import {
  FaLinkedin,
  FaBehance,
  FaEnvelopeSquare
} from "react-icons/lib/fa";

const SocialLinks = () => (
  <ul className="social">
    
    <li>
      <a href = "https://www.linkedin.com/in/jaka-hrepevnik/" > 
      <FaLinkedin />
      </a>
    </li>
    <li>
      < a href = "https://www.behance.net/yots" >
        <FaBehance />
      </a>
    </li>
    <li>
      <a href="mailto:jaka@hrepevnik.com">
      < FaEnvelopeSquare / >
      </a>
    </li>
  </ul>
);

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/components/SocialLinks.js